import { AdminIntakeHubDefinitionsPanel } from '@features/intake-hub/AdminIntakeHubDefinitionsPanel';

import { AppHeader } from '../components/app-header';
import { BackButton } from '../components/back-button';

export default function IntakeHubAdminPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AppHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-4">
          <BackButton fallbackUrl="/admin-v2" />
        </div>
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Intake Hub</h1>
          <p className="mt-1 text-sm text-gray-600">
            Manage the global service and requirement definition catalog.
          </p>
        </div>
        <AdminIntakeHubDefinitionsPanel />
      </main>
    </div>
  );
}
